import type { PageProps } from "types/global";
import type { MagnitudePageProps } from "types/magnitude";

export const isMagnitudeTemplate = (props: PageProps): props is MagnitudePageProps =>
  ["magnitude", "magnitudeTopic"].includes(props.templateComponent);
